module.exports = __webpack_public_path__ + "static/media/turmeric_getty_tablet.b1d1292f.jpg";